// @flow

import React from 'react';

import { RenderTableActionButtons } from '../../../commons/tableActionButton/tableActionButton';
import { zoomTableActionsConfig } from '../../../commons/zoomTable/zoomTableConfig';
import { SelectedCheckedIcon } from '../../../commons/icons/icons';
import envConfig from '../../../../configs/envConfig';
import { zoomConstants } from '../../../../services/apiService/apiEndPoints';
import {
  networkToolDagStatus,
  networkToolDagActions
} from '../networkPlanningHelper';
import { getRetailTableCellObject } from '../../../../services/helpers';

export const networkGlobalConfigId = 226;

const returnAction = rowData => {
  switch (rowData.status) {
    case networkToolDagStatus.READY:
      return [
        networkToolDagActions.RUN,
        networkToolDagActions.EDIT,
        networkToolDagActions.DELETE
      ];
    case networkToolDagStatus.INCOMPLETE:
      return [networkToolDagActions.COMPLETE, networkToolDagActions.DELETE];
    case networkToolDagStatus.QUEUED:
      return [networkToolDagActions.DEQUEUE];
    case networkToolDagStatus.RUNNING:
      return [networkToolDagActions.STOP];
    case networkToolDagStatus.STOPPED:
      return [networkToolDagActions.RE_RUN];
    case networkToolDagStatus.COMPLETE:
      return [networkToolDagActions.DOWNLOAD, networkToolDagActions.RE_RUN];
    case networkToolDagStatus.SUCCESS:
      return [networkToolDagActions.DOWNLOAD, networkToolDagActions.RE_RUN];
    case networkToolDagStatus.FAILED:
      return [networkToolDagActions.RE_RUN];

    default:
      return [];
  }
};

export const nlhSelectionButtonConfig = {
  buttons: [
    {
      // Selection button
      iconOnly: true,
      iconStyle: { opacity: 1 },
      iconCb: row =>
        row.isSelected ? (
          <SelectedCheckedIcon color="#3e82f7" />
        ) : (
          <SelectedCheckedIcon color="lightgray" />
        ),
      onClick: rowData => {
        // eslint-disable-next-line no-console
        // console.log("Edit clicked row {} ", rowData);
        zoomTableActionsConfig.NATIONAL_LINE_HAUL.actions.handleRowSelection(
          rowData
        );
      },
      style: {
        // Camel case all your known styles. x% width equals x% of 140px.
        width: '20%',
        height: '50%',
        margin: '5%'
      }
    }
  ]
};

const hideButton = (rowData, index) => {
  [rowData.action] = [returnAction(rowData)[index]];
  return (
    zoomTableActionsConfig.NATIONAL_LINE_HAUL.actions.hideActionButton &&
    zoomTableActionsConfig.NATIONAL_LINE_HAUL.actions.hideActionButton(rowData)
  );
};

export const nationalLineHaulButtonConfig = {
  buttons: [
    {
      // Edit button
      labelOnly: true,
      label: rowData => returnAction(rowData)[0],
      onClick: rowData => {
        // eslint-disable-next-line no-console
        console.log('Edit clicked row {} ', rowData);
        [rowData.action] = [returnAction(rowData)[0].toUpperCase()];
        zoomTableActionsConfig.NATIONAL_LINE_HAUL.actions.handleAction(rowData);
      },
      hide: rowData => hideButton(rowData, 0),
      style: {
        // Camel case all your known styles. x% width equals x% of 140px.
        height: '50%',
        margin: '5%',
        marginLeft: 0
      }
    },
    {
      // Edit button
      labelOnly: true,
      label: rowData => returnAction(rowData)[1],

      onClick: rowData => {
        // eslint-disable-next-line no-console
        console.log('Edit clicked row {} ', rowData);
        [rowData.action] = [returnAction(rowData)[1].toUpperCase()];
        zoomTableActionsConfig.NATIONAL_LINE_HAUL.actions.handleAction(rowData);
      },
      hide: rowData => hideButton(rowData, 1),
      style: {
        height: '50%',
        margin: '5%',
        marginLeft: 0
      }
    },
    {
      // Edit button
      labelOnly: true,
      label: rowData => returnAction(rowData)[2],
      onClick: rowData => {
        // eslint-disable-next-line no-console
        console.log('Edit clicked row {} ', rowData);
        [rowData.action] = [returnAction(rowData)[2].toUpperCase()];
        zoomTableActionsConfig.NATIONAL_LINE_HAUL.actions.handleAction(rowData);
      },
      hide: rowData => hideButton(rowData, 2),
      style: {
        height: '50%',
        margin: '5%',
        marginLeft: 0
      }
    }
  ]
};

export const nationalLineHaulTableConfig = {
  columns: [
    {
      Cell: (row: Object) => (
        <RenderTableActionButtons
          buttonConfig={nlhSelectionButtonConfig.buttons}
          rowData={row.original || {}}
          modalTheme={{ name: 'white' }}
        />
      ),
      width: 100
    },
    {
      Header: 'ID',
      accessor: 'id',
      Cell: (row: Object) => (
        <div className="text-wrap-ellipsis" title={row.original.configId}>
          {row.original.configId}
        </div>
      )
    },
    {
      Header: 'Description',
      accessor: 'description',
      Cell: (row: Object) => (
        <div className="wrap-big-text" title={row.original.description}>
          {row.original.description}
        </div>
      ),
      width: 250
    },
    {
      Header: 'Status',
      accessor: 'status',
      Cell: (row: Object) => (
        <div className="text-wrap-ellipsis" title={row.original.status}>
          {row.original.status}
        </div>
      )
    },
    {
      Header: 'Last Completed Stage',
      accessor: 'lastCompletedStage',
      Cell: (row: Object) =>
        getRetailTableCellObject(row.original.lastCompletedStage, ''),
      width: 150
    },
    {
      Header: 'Action',
      Cell: (row: Object) => (
        <RenderTableActionButtons
          buttonConfig={nationalLineHaulButtonConfig.buttons}
          rowData={row.original || {}}
          modalTheme={{ name: 'white' }}
        />
      ),

      width: 400
    }
  ],
  className: `nlh-table flex-100`,
  defaultPageSize: 2,
  noDataText: 'No data found',
  minRows: 0,
  style: { height: 'calc(100vh - 27rem)', borderRadius: '1rem', opacity: '1' }
};

export const checkButtonAccess = (rowData, userProfile) => {
  switch (rowData.action) {
    case networkToolDagActions.RUN:
      return (
        userProfile.authorities &&
        userProfile.authorities.indexOf('ROLE_RUN_NETWORK_TOOL') === -1
      );
    case networkToolDagActions.COMPLETE:
      return (
        userProfile.authorities &&
        userProfile.authorities.indexOf('ROLE_COMPLETE_NETWORK_TOOL') === -1
      );
    case networkToolDagActions.EDIT:
      return (
        userProfile.authorities &&
        userProfile.authorities.indexOf('ROLE_EDIT_NETWORK_TOOL') === -1
      );
    case networkToolDagActions.DELETE:
      return (
        userProfile.authorities &&
        userProfile.authorities.indexOf('ROLE_DELETE_NETWORK_TOOL') === -1
      );
    case networkToolDagActions.STOP:
      return (
        userProfile.authorities &&
        userProfile.authorities.indexOf('ROLE_STOP_NETWORK_TOOL') === -1
      );
    case networkToolDagActions.RE_RUN:
      return (
        userProfile.authorities &&
        userProfile.authorities.indexOf('ROLE_RE_RUN_NETWORK_TOOL') === -1
      );
    case networkToolDagActions.DOWNLOAD:
      return (
        userProfile.authorities &&
        userProfile.authorities.indexOf('ROLE_DOWNLOAD_NETWORK_TOOL') === -1
      );
    case networkToolDagActions.DEQUEUE:
      return (
        userProfile.authorities &&
        userProfile.authorities.indexOf('ROLE_DEQUEUE_NETWORK_TOOL') === -1
      );

    default:
      return null;
  }
};

export const setIsSelectedFlag = (tableData, rowData) => {
  const index = tableData
    ? tableData.findIndex(row => row.configId === rowData.configId)
    : -1;
  if (index !== -1) {
    tableData[index].isSelected = rowData.isSelected;
  }
  return tableData;
};

export const getSelectedConfigList = tableData => {
  if (!tableData) {
    return [];
  }
  const configList = [];
  tableData.forEach(row => {
    if (row.isSelected) {
      configList.push(row.configId);
    }
  });
  return configList;
};

export const navigateToSupersetDashboard = configList => {
  const presetFilters = {};
  presetFilters[networkGlobalConfigId] = {};
  presetFilters[networkGlobalConfigId].config_id = configList;
  const stringifiedPresetFilters = JSON.stringify(presetFilters);
  const params = `preselect_filters=${stringifiedPresetFilters}&standalone=true`;
  const a = document.createElement('a');
  a.href = `${envConfig.zoomSuperSetUrl}${zoomConstants.networkSupersetDashboard}?${params}`;
  a.target = 'new';
  a.click();
};
